import { Injectable, EventEmitter } from '@angular/core';

import { SettingsService } from '../settings/settings.service';
import { PlayerComponent } from './player.component';
import { delay } from '../app.utils';

@Injectable({
	providedIn: 'root'
})
export class PlayerService {

	should_play_muted: boolean = true; //Autoplay only allowed without music


	constructor( private settings: SettingsService ){
		this.autoplay_setup();
		this.resize_observe();
	}

	players: { [key: string]: PlayerComponent } = {}; //player_id -> player_component

	selected_player_id: string = null;
	on_selected_player_change: EventEmitter<string> = new EventEmitter();
	select( pid ){
		if( pid === undefined ) pid = null;
		if( pid == this.selected_player_id ) return;
		this.selected_player_id = pid;
		this.on_selected_player_change.emit(pid);
	}

	register( player: PlayerComponent ){
		this.players[player.id] = player;

		if( this.selected_player_id === null )
			this.select(player.id);

		if( this.selected_player_id != player.id )
			player.message("Tap to select this player", "Then, select a stream from the menu.")
	}
	unregister( player: PlayerComponent ){
		delete this.players[player.id];

		if( this.selected_player_id == player.id )
			this.select( Object.keys(this.players)[0] );
	}

	unmute_shown: boolean = true;
	get tv24all_url(){ return this._sp && this._sp.is_playing() && this._sp.tv24all_url; }

	is_any_player_playing(){
		for( let p of Object.values(this.players) )
			if( p.is_playing() )
				return true;
		return false;
	}


	//selected_player, and basic / proxy methods
	get _sp(){ return this.players[this.selected_player_id]; }


	resize_observer: ResizeObserver = null;
	resize_parent: HTMLElement = null;
	resize_aspect_ratio_fix_timeout = null;
	resize_aspect_ratio_fix_ongoing = false;
	resize_observe(){
		this.resize_parent = document.querySelector("app-tvbox");
		this.resize_observer = new ResizeObserver( () => this.resize() );
		this.resize_observer.observe( this.resize_parent );
	}
	resize(){
		for( let p of Object.values(this.players) ) p.resize();

		if( this.resize_aspect_ratio_fix_ongoing ) return;

		if( this.resize_aspect_ratio_fix_timeout )
			clearTimeout( this.resize_aspect_ratio_fix_timeout );
		this.resize_aspect_ratio_fix_timeout = setTimeout( ()=>this.resize_aspect_ratio_fix(), 50 );
	}
	resize_aspect_ratio_is_ok(){
		let screen = this.resize_parent.querySelector<HTMLElement>("div.screen");
		if( screen.offsetWidth < this.resize_parent.offsetWidth ) return false;

		//Run a more expensive test to be sure it really is ok!
		//https://stackoverflow.com/a/21689320
		let rect = screen.getBoundingClientRect();
		return (
			rect.top >= 0 && rect.left >= 0 &&
			rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
			rect.right <= (window.innerWidth || document.documentElement.clientWidth)
		);

	}
	async resize_aspect_ratio_fix(){
		this.resize_aspect_ratio_fix_ongoing = true;

		if( this.resize_aspect_ratio_is_ok() ){
			await delay(10);
			this.resize_aspect_ratio_fix_ongoing = false;
			return;
		}

		//Basically, only iOS devices bellow here:
		let screen = this.resize_parent.querySelector<HTMLElement>("div.screen");

		console.log("Fixing aspect ratio bug!")
		screen.style.aspectRatio = "unset";
		await delay(0);
		screen.style.aspectRatio = null;

		await delay(10);
		if( this.resize_aspect_ratio_is_ok() ){
			await delay(10);
			this.resize_aspect_ratio_fix_ongoing = false;
			return;
		}

		console.log("Fixing aspect ratio bug even harder!!")
		screen.style.aspectRatio = "unset";
		await delay(10);
		screen.style.aspectRatio = null;

		await delay(10);
		this.resize_aspect_ratio_fix_ongoing = false;
	}



	get media_event(){ return this._sp && this._sp.media_event; }
	get flavor(){ return this._sp && this._sp.flavor; }
	assign( media_event, flavor = null ){
		this.autoplay_queued = false;
		this._sp.assign( media_event, flavor );
	}
	stop(){
		this._sp.stop();
	}




	autoplay_policy: string = "allowed-muted"; // allowed, allowed-muted, disallowed
	autoplay_queued: boolean = false;
	autoplay_setup(){

		//Decide on autoplay details
		if( !this.settings.autoplay_enabled )
			this.autoplay_policy = "disallowed";
		else if( navigator['getAutoplayPolicy'] )
			this.autoplay_policy = navigator['getAutoplayPolicy']("mediaelement");
		else if( this.settings.autoplay_muted )
			this.autoplay_policy = "allowed";
		this.autoplay_queued = this.autoplay_policy != "disallowed";

	}


	//Report Consolidating
	last_player_error_json: any = null;
	get last_player_error(){ return this.last_player_error_json }
	set last_player_error(v){
		let report = {};
		const report_keys = [
			"code", "description", "level",
			"origin",
			"scope",
			"raw.url"
		];

		for( let key of report_keys ){
			let rkey = key.replace( /\./g, '"]["' );
			try { report[key] = (new Function('v', `return v["${rkey}"]`))(v) }
			catch(e){ }
		}

		this.last_player_error_json = report;
	}






}
